import { Component, inject } from '@angular/core';

import { NotificationService } from '../../../core/services/notification.service';
import { IconComponent } from '../icon/icon.component';

/** Renderiza los toasts del NotificationService (esquina superior derecha). */
@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [IconComponent],
  template: `
    <div class="toasts" aria-live="polite">
      @for (toast of notifications.toasts(); track toast.id) {
        <div class="toast" [class]="'toast toast--' + toast.type" (click)="notifications.dismiss(toast.id)">
          <span class="toast__icon"><app-icon [name]="icon(toast.type)" [size]="18" /></span>
          <span class="toast__message">{{ toast.message }}</span>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .toasts {
        position: fixed;
        top: var(--space-4);
        right: var(--space-4);
        z-index: var(--z-toast);
        display: flex;
        flex-direction: column;
        gap: var(--space-2);
        max-width: 360px;
      }
      .toast {
        display: flex;
        align-items: flex-start;
        gap: var(--space-2);
        padding: var(--space-3) var(--space-4);
        border-radius: var(--radius-sm);
        background: var(--color-floating);
        border: 1px solid var(--color-border);
        box-shadow: var(--shadow-floating);
        font-size: var(--fs-body-md);
        cursor: pointer;
        animation: toast-in var(--motion) var(--ease);
      }
      .toast--success { border-left: 4px solid var(--color-success); }
      .toast--error { border-left: 4px solid var(--color-danger); }
      .toast--warning { border-left: 4px solid var(--refac-yellow-85); }
      .toast--info { border-left: 4px solid var(--color-accent); }
      /* En móvil ocupan el ancho útil para no cortar el mensaje. */
      @media (max-width: 639.98px) {
        .toasts {
          left: var(--space-3);
          right: var(--space-3);
          top: var(--space-3);
          max-width: none;
        }
      }
      @keyframes toast-in {
        from { transform: translateY(-6px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `,
  ],
})
export class ToastContainerComponent {
  readonly notifications = inject(NotificationService);

  icon(type: string): string {
    return { success: 'check-circle', error: 'x-circle', warning: 'alert-triangle', info: 'info' }[type] ?? 'info';
  }
}
